module.exports = __webpack_public_path__ + "img/road-transparent.ca8e95fd.jpg";